var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "assistant-cat-mode-dialog-mask" },
    [
      _c(
        "div",
        {
          staticClass: "assistant-cat-mode-dialog-content",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-header" }, [
            _c("h2", { staticClass: "dialog-title" }, [
              _vm._v(
                _vm._s(_vm.$t("myPage.feedbackManuscriptModeDialog.title"))
              ),
            ]),
            _c(
              "button",
              {
                staticClass: "close-button",
                attrs: {
                  type: "button",
                  "aria-label": _vm.closeButtonAriaLabel,
                },
                on: { click: _vm.handleClose },
              },
              [_c("span", { staticClass: "close-icon" }, [_vm._v("×")])]
            ),
          ]),
          _vm.error
            ? _c("div", { staticClass: "error-container" }, [
                _c("p", { staticClass: "error-message" }, [
                  _vm._v(_vm._s(_vm.error)),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "retry-button",
                    attrs: { type: "button" },
                    on: { click: _vm.handleRetry },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "myPage.feedbackManuscriptModeDialog.retryButton"
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ])
            : _c("div", { staticClass: "dialog-body" }, [
                _c("div", { staticClass: "speech-wrapper" }, [
                  _c("div", { staticClass: "speech-bubble" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("myPage.feedbackManuscriptModeDialog.question")
                      )
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "cat-icon-container" },
                    [
                      _c("CatIcon", {
                        attrs: { clickable: false, size: "medium" },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "mode-container" },
                  _vm._l(_vm.modeOptions, function (option) {
                    return _c(
                      "article",
                      { key: option.mode, staticClass: "mode-card" },
                      [
                        _c("div", { staticClass: "mode-card-icon" }, [
                          _c("img", {
                            attrs: { src: option.icon, alt: option.mode },
                          }),
                        ]),
                        _c("div", [
                          _c("p", { staticClass: "mode-card-title" }, [
                            _vm._v(_vm._s(option.title)),
                          ]),
                          _c("p", { staticClass: "mode-card-description" }, [
                            _vm._v(_vm._s(option.descriptionLine1)),
                          ]),
                          _c("p", { staticClass: "mode-card-description" }, [
                            _vm._v(" " + _vm._s(option.descriptionLine2) + " "),
                          ]),
                          _c("p", { staticClass: "mode-card-cost" }, [
                            _vm._v(_vm._s(_vm.costLabelText(option.mode))),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "mode-card-button",
                              attrs: {
                                type: "button",
                                disabled:
                                  option.mode === _vm.currentMode ||
                                  _vm.isLoading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleChangeMode(option.mode)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    option.mode === _vm.currentMode
                                      ? _vm.$t(
                                          "myPage.feedbackManuscriptModeDialog.selectedButton"
                                        )
                                      : _vm.$t(
                                          "myPage.feedbackManuscriptModeDialog.changeButton"
                                        )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "note-wrapper" }, [
                  _c("p", [
                    _vm._v(
                      " ※" +
                        _vm._s(
                          _vm.$t(
                            "myPage.feedbackManuscriptModeDialog.dryModeExtraCostNote",
                            { extraFish: _vm.formattedDryModeExtraFish }
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "※" +
                        _vm._s(
                          _vm.$t(
                            "myPage.feedbackManuscriptModeDialog.dryModeDisclaimerNote"
                          )
                        )
                    ),
                  ]),
                ]),
              ]),
        ]
      ),
      _vm.showSkipDialog
        ? _c("WriterTypeIndicatorSkipDialog", {
            on: {
              close: function ($event) {
                _vm.showSkipDialog = false
              },
              done: _vm.handleClose,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }